"use client";

import { LIVE_CLOSE_BUFFER_DAYS } from "@/lib/constants";
import { useAuctionTime } from "@/lib/context/AuctionTimeProvider";
import { getAuctionTimeString } from "@/lib/utils";
import { AuctionState, AuctionType } from "@prisma/client";
import { Flex, Text } from "@radix-ui/themes";
import classNames from "classnames";
import { minutesToMilliseconds } from "date-fns";
import React from "react";

interface Props {
  endDate: Date;
  auctionStart: Date;
  auctionState: AuctionState;
  auctionType: AuctionType;
  className?: string;
}

const CLOSE_TO_FINISH_STATES: AuctionState[] =
  [AuctionState.AUCTION, AuctionState.SOFT_CLOSING];

const LotPreviewClock = (
  { endDate, auctionState, auctionStart, auctionType, className }: Props
) => {
  const { currentTime } = useAuctionTime();
  const timeLeft = (new Date(endDate)).getTime() - (new Date(currentTime)).getTime();

  const closeToFinish = CLOSE_TO_FINISH_STATES.includes(auctionState) &&
    timeLeft < minutesToMilliseconds(5) &&
    timeLeft > 0;

  let timeLeftString = "";
  
  if (timeLeft < LIVE_CLOSE_BUFFER_DAYS * 24 * 60 * 60 * 1000 || auctionType !== AuctionType.HYBRID) {
    timeLeftString = getAuctionTimeString(auctionState, auctionStart, timeLeft);

    if (auctionType === AuctionType.HYBRID && auctionState === AuctionState.AUCTION) {
      if (timeLeftString === "Closed") {
        timeLeftString = "Live Close";
      } else {
        const cleanTimeString = timeLeftString.endsWith(' left') ? timeLeftString.slice(0, -5) : timeLeftString;
        timeLeftString = `${cleanTimeString} until live close`;
      }
    }
  }

  return (
    <Flex
      justify="center"
      align="center"
      className={classNames(
        "absolute h-7 z-30 rounded-tr-lg bottom-0 left-0",
        "bg-zinc-100 bg-opacity-40 overflow-hidden px-2 whitespace-nowrap",
      )}
      style={{
        backdropFilter: "blur(15px)",
        width: "max-content",
      }}
    >
      <Text
        className={classNames(
          "text-sm",
          closeToFinish && "text-red-500"
        )}
      >
        {timeLeftString}
      </Text>
    </Flex>
  );
};

export default LotPreviewClock;
